$(function() {

    //Mobile nav toggle
    $body.on('click', '.mobile-menu', function(e) {
        e.preventDefault();
        var $nav = $('.navigation');

        if($nav.is(':visible')) {
            $nav.slideUp();
        } else {
            $nav.slideDown();
        }
    });

    //Reset styling for mobile nav menu if they size up to full-menu width
    $(window).on('resize orientationchange', function(e) {
        var $nav = $('.navigation');

        if($(this).width() >= 992) {
            $nav.removeAttr('style');
        }

    });

});
